import { Routes } from '@angular/router';
import { configGuard } from '@shared/guards/config.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    canActivate: [configGuard],
    loadComponent: () => import('./modules/tesouraria/components/tesouraria/tesouraria.component').then((c) => c.TesourariaComponent),
    loadChildren: () => import('./modules/tesouraria/tesouraria.routes').then((r) => r.tesourariaRoutes)
  }
];
